
<div class="env-widget-container" @click="handleClick($event)">
	<div class="env-widget-header">
		<div class="env-header-meta">
			<h1 class="fc-dark text-ellipsis">
				{{ title }}
			</h1>
			<h6 v-if="subTitle" class="fw-normal fc-light text-ellipsis">
				{{ subTitle }}
			</h6>
		</div>
		<div class="env-widget-settings-icon">
			<Icon name="settings" type="filled" size="small" @click="settings($event)" />
		</div>
	</div>
	<div class="env-widget-body">
		<!-- @slot Used to display env widget meta data -->
		<slot />
	</div>
	<div class="env-widget-footer">
		<div class="env-footer-meta">
			<div class="env-footer-label fc-light">
				<h6 class="fw-normal fc-light upper-case text-ellipsis">
					{{ footerLabel }}
				</h6>
			</div>
			<div class="env-footer-toggle">
				<Icon
					:name="'menu-down'"
					type="filled"
					size="small"
					:rotate="innerFooterExpanded ? 0 : 180"
					@click="toggleFooter($event)"
				/>
			</div>
		</div>
		<div class="env-app-grid" :compact="!innerFooterExpanded">
			<!-- @slot Used to display environments -->
			<slot name="footer" />
		</div>
	</div>
</div>
